/* eslint-disable  */
import React, { useEffect, useState } from 'react'
import tag from './tag.jpg'
const ImageOptions = props => {
  const { copyRight, shareImage, copyRightText } = props
  const [copyrightTextType, setCopyrightTextType] = React.useState('custom')
  const key = props.item.key ? props.item.key : props.item.image
  const [size1, setSize] = useState('')
  const [size2, setSize2] = useState('')
  const [size3, setSize3] = useState('')
  const [size4, setSize4] = useState('')
  const [sizeblur1, setsizeblur1] = useState('')
  const [sizeblur2, setsizeblur2] = useState('')

  const [sizeblur3, setsizeblur3] = useState('')

  const changeCopyrightTextType = (type, value) => {
    setCopyrightTextType(type)
    props.handleCopyrightType(key, value, props.sectionIndex)
    props.handleCopyrightText(key, value, props.sectionIndex)
  }

  useEffect(() => {
    const getLoggedInUserPermissions = async () => {
      let type = copyrightTextType
      switch (copyRightText) {
        case '© ANI Photo':
          type = 'ANI'
          break
        case 'Courtesy Instagram:':
          type = 'courtesyInsta'
          break
        case 'Screengrab Instagram:':
          type = 'screengrabInsta'
          break
        case 'Courtesy Twitter:':
          type = 'courtesyTwitter'
          break
        case 'Screengrab Twitter:':
          type = 'screengrabTwitter'
          break
        case '© IPL Photos - IPLT40.com':
          type = 'iplPhotos'
          break
        case '© Envato':
          type = 'envatoElements'
          break
        case '© File Photo':
          type = 'filePhoto'
          break
        case 'Movies':
          type = 'Movies'
          break
        default:
          type = 'custom'
      }

      setCopyrightTextType(type)
      if (!copyRight && copyRightText === 'Movies') {
        props.handleCopyrightText(key, 'Movies', props.sectionIndex)
      }
    }

    getLoggedInUserPermissions()
  }, [])
  const positionval = (e, key) => {
    const sizeval = e.target.value
    setSize(sizeval)
    const imageSizeObj = { width: '109%' }

    props.handleImageSize(key, imageSizeObj)
  }

  const positionval2 = (e, key) => {
    const sizeval2 = e.target.value
    setSize2(sizeval2)
    const imageSizeObj = {
      position: 'absolute',
      width: '142%',
      left: '0%',
      // "padding":"25px 0px"
    }

    props.handleImageSize(key, imageSizeObj)
  }

  const positionval3 = (e, key) => {
    const sizeval3 = e.target.value
    setSize3(sizeval3)
    const imageSizeObj = {
      position: 'absolute',
      width: '142%',
      left: '-26%',
      //  "padding":"25px 0px"
    }

    props.handleImageSize(key, imageSizeObj)
  }

  const positionval4 = (e, key) => {
    const sizeval4 = e.target.value
    setSize4(sizeval4)
    const imageSizeObj = {
      position: 'absolute',
      width: '194%',
      left: '-96%',
      //  "padding":"25px 0px"
    }

    props.handleImageSize(key, imageSizeObj)
  }

  const positionval_blur1 = (e, key) => {
    const sizeval4 = e.target.value
    setsizeblur1(sizeval4)
    const imageSizeObj = {
      padding: '47px ',
      backdropFilter: 'blur(1px)',
    }
    props.handleImageSize(key, imageSizeObj)
  }

  const positionval_blur2 = (e, key) => {
    const sizeval4 = e.target.value
    setsizeblur2(sizeval4)
    const imageSizeObj = {
      padding: '47px ',
      backdropFilter: 'blur(2px)',
    }
    props.handleImageSize(key, imageSizeObj)
  }

  const positionval_blur3 = (e, key) => {
    const sizeval4 = e.target.value
    setsizeblur3(sizeval4)
    const imageSizeObj = {
      padding: '47px ',
      backdropFilter: 'blur(3px)',
    }

    props.handleImageSize(key, imageSizeObj)
  }
  // switch(sizeval){
  //   case "None":
  //     imageSizeObj = {
  //       // "position":"absolute",
  //       "width":"109%",
  //       // "left":"0%"
  //     }
  //     break;
  //   case "first 1/3":
  //     imageSizeObj = {
  //       "position":"absolute",
  //       "width":"220%",
  //       "left":"0%"
  //     }
  //     break;
  //   case "second 1/3":
  //     imageSizeObj = {
  //       "position":"absolute",
  //       "width":"220%",
  //       "left":"-60%"
  //     }
  //     break;
  //   case "third 1/3":
  //     imageSizeObj = {
  //       "position":"absolute",
  //       "width":"220%",
  //       "left":"-119%"
  //     }

  //     break;
  //   default:
  //     imageSizeObj = {
  //   "position":"relative",
  //       "width":"109%",
  //       "left":"-5%"

  //     }
  //     break;
  // }
  return (
    <div>
      {/* <div style={{
        display: "flex", position: "relative",
        top: " 11px", gap: "10px"
       }}>
        <div style={{
          display: "flex", flexDirection: "column", backgroundImage: `url(${props.srcImg})`, backgroundRepeat: "no-repeat",
          backgroundSize: "68px 53px",
        }}>
          <img src={props.srcImg} style={{
            width: "70px", marginBottom: "10px",
            marginBottom: "10px",
            padding: "8px",
            position: "relative",
            right: "1px",
            top: "0px",
            height: "54px",
            backdropFilter: "blur(0.7px)", border: "1px solid black"
          }} />

          <div><lable>Blur 1</lable>
            <input type="radio" id="imageSize" name="imageSize" onChange={(e) => positionval_blur1(e, key)} value={sizeblur1} />
          </div></div>
        <div style={{
          display: "flex", flexDirection: "column", backgroundImage: `url(${props.srcImg})`, backgroundRepeat: "no-repeat",
          backgroundSize: "68px 53px",
        }}>
          <img src={props.srcImg} style={{
            width: "70px", marginBottom: "10px",
            marginBottom: "10px",
            padding: "8px",
            position: "relative",
            right: "1px",
            top: "0px",
            height: "54px",
            backdropFilter: "blur(1px)", border: "1px solid black"
          }} />

          <div><lable>Blur 2</lable>
            <input type="radio" id="imageSize" name="imageSize" onChange={(e) => positionval_blur2(e, key)} value={sizeblur2} />
          </div></div>
        <div style={{
          display: "flex", flexDirection: "column", backgroundImage: `url(${props.srcImg})`, backgroundRepeat: "no-repeat",
          backgroundSize: "68px 53px",
        }}>
          <img src={props.srcImg} style={{
            width: "70px", marginBottom: "10px",
            marginBottom: "10px",
            padding: "8px",
            position: "relative",
            right: "1px",
            top: "0px", height: "54px",
            backdropFilter: "blur(1.5px)", border: "1px solid black"
          }} />

          <div><lable>Blur 3</lable>
            <input type="radio" id="imageSize" name="imageSize" onChange={(e) => positionval_blur3(e, key)} value={sizeblur3} />
          </div></div>
      </div> */}
      {/* <div style={{ marginTop: "17px" }}>
        <img src={props.srcImg} style={{ width: "70px", marginBottom: "10px" }} />
        <lable>None</lable>
        <input type="radio" id="imageSize" name="imageSize" onChange={(e) => positionval(e, key)} value={size1} />
      </div> */}
      {/* <div style={{ display: "flex", flexDirection: "column", marginBottom: "10px" }}>
        <lable>image partition</lable>
        <div style={{ display: "flex" }}>
          <div style={{ display: "flex" }}>
            <div style={{
              width: "33px",
              overflow: "hidden"
            }}>
              <img src={props.srcImg} style={{
                width: "100px",
                position: "relative",
                left: "-12px",
                height: "63px"
              }} />
            </div>
            <input type="radio" style={{ marginRight: "7px" }} id="imageSize" name="imageSize" onChange={(e) => positionval2(e, key)} value={size2} />
          </div>
          <div style={{ display: "flex" }}>
            <div style={{
              width: "33px",
              overflow: "hidden"
            }}>
              <img src={props.srcImg} style={{
                width: "100px",
                position: "relative",
                left: "-36px",
                height: "63px"
              }} />
            </div>
            <input type="radio" style={{ marginRight: "7px" }} id="imageSize" name="imageSize" onChange={(e) => positionval3(e, key)} value={size3} />
          </div>
          <div style={{ display: "flex" }}>
            <div style={{
              width: "33px",
              overflow: "hidden"
            }}>
              <img src={props.srcImg} style={{
                width: "104px",
                position: "relative",
                left: "-71px",
                height: "63px"
              }} />
            </div>
            <input type="radio" id="imageSize" style={{ marginRight: "7px" }} name="imageSize" onChange={(e) => positionval4(e, key)} value={size4} />
          </div>
        </div>
      </div> */}

      <div className='row'>
        <div className='col-md-5'>
          <input
            type='checkbox'
            onClick={() => {
              props.toggleCopyRightSwitch(key, props.sectionIndex)
            }}
            checked={copyRight}
          ></input>
          <text htmlFor='text'> Copy Right </text>
        </div>
        <div className='col-md-5'>
          <input
            type='checkbox'
            onClick={() => props.toggleShareImageSwitch(key, props.sectionIndex)}
            checked={shareImage}
          ></input>
          <text htmlFor='text'> Share Image </text>
        </div>
      </div>
      {copyRight ? (
        <div>
          <div style={{ flexDirection: 'row' }}>
            <text style={{ fontWeight: 'bold' }}>CopyRight Text : </text>
            <text>{copyRightText}</text>
          </div>
          <div style={{ flexDirection: 'row' }}>
            <input
              type='checkbox'
              onClick={() => changeCopyrightTextType('custom', '')}
              checked={copyrightTextType === 'custom'}
            ></input>
            <text htmlFor='text'>Custom</text>
          </div>
          <div style={{ flexDirection: 'row' }}>
            <input
              type='checkbox'
              onClick={() => {
                changeCopyrightTextType('ANI', '© ANI Photo')
              }}
              checked={copyrightTextType === 'ANI'}
            ></input>
            <text htmlFor='text'>© ANI Photo</text>
          </div>
          <div style={{ flexDirection: 'row' }}>
            <input
              type='checkbox'
              onClick={() => changeCopyrightTextType('courtesyInsta', 'Courtesy Instagram:')}
              checked={copyrightTextType === 'courtesyInsta'}
            ></input>
            <text htmlFor='text'>Courtesy Instagram:</text>
          </div>
          <div style={{ flexDirection: 'row' }}>
            <input
              type='checkbox'
              onClick={() => changeCopyrightTextType('screengrabInsta', 'Screengrab Instagram:')}
              checked={copyrightTextType === 'screengrabInsta'}
            ></input>
            <text htmlFor='text'>Screengrab Instagram:</text>
          </div>
          <div style={{ flexDirection: 'row' }}>
            <input
              type='checkbox'
              onClick={() => changeCopyrightTextType('courtesyTwitter', 'Courtesy Twitter:')}
              checked={copyrightTextType === 'courtesyTwitter'}
            ></input>
            <text htmlFor='text'>Courtesy Twitter:</text>
          </div>
          <div style={{ flexDirection: 'row' }}>
            <input
              type='checkbox'
              onClick={() => changeCopyrightTextType('screengrabTwitter', 'Screengrab Twitter:')}
              checked={copyrightTextType === 'screengrabTwitter'}
            ></input>
            <text htmlFor='text'>Screengrab Twitter:</text>
          </div>

          <div style={{ flexDirection: 'row' }}>
            <input
              type='checkbox'
              onClick={() => changeCopyrightTextType('iplPhotos', '© IPL Photos - IPLT20.com')}
              checked={copyrightTextType === 'iplPhotos'}
            ></input>
            <text htmlFor='text'>© IPL Photos - IPLT20.com</text>
          </div>
          <div style={{ flexDirection: 'row' }}>
            <input
              type='checkbox'
              onClick={() => changeCopyrightTextType('envatoElements', '© Envato')}
              checked={copyrightTextType === 'envatoElements'}
            ></input>
            <text htmlFor='text'>© Envato</text>
          </div>
          <div style={{ flexDirection: 'row' }}>
            <input
              type='checkbox'
              onClick={() => changeCopyrightTextType('filePhoto', '© File Photo')}
              checked={copyrightTextType === 'filePhoto'}
            ></input>
            <text htmlFor='text'>© File Photo</text>
          </div>
          <div style={{ flexDirection: 'row' }}>
            <input
              type='checkbox'
              onClick={() => changeCopyrightTextType('Movies', 'Movies')}
              checked={copyrightTextType === 'Movies'}
            ></input>
            <text htmlFor='text'>Movies</text>
          </div>

          <input
            type='text'
            onChange={e => {
              props.handleCopyrightText(key, e.target.value, props.sectionIndex)
            }}
            value={copyRightText}
            placeholder='Please Enter CopyRight Text'
          ></input>
        </div>
      ) : null}
      {!copyRightText && props.syncToWordpress ? (
        <text htmlFor='text' style={{ color: 'red', fontSize: 10 }}>
          Copy Right Text Cannot Be Empty
        </text>
      ) : null}
    </div>
  )
}

export default ImageOptions
